<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

    <!-- breadcrumb start -->
    <app-breadcrumb-one title="Register" subtitle="Register"></app-breadcrumb-one>
    <!-- breadcrumb end -->

   <!-- register Area start-->
   <section class="login-area pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="basic-login">
                    <h3 class="text-center mb-60">Signup</h3>
                    <form [formGroup]="registerForm" (ngSubmit)="onSubmit(registerForm.value)">
                        <div class="mb-20">
                          <label for="first_name">First Name <span>*</span></label>
                          <input id="first_name" type="text" placeholder="Enter First Name" formControlName="first_name" />
                          <span *ngIf="formSubmitted && registerForm.controls?.['first_name']?.errors?.['required']"  class="text-danger">
                            First Name is required
                          </span>
                        </div>
                        <div class="mb-20">
                          <label for="last_name">Last Name <span>*</span></label>
                          <input id="last_name" type="text" placeholder="Enter Last Name" formControlName="last_name" />
                          <span *ngIf="formSubmitted && registerForm.controls?.['last_name']?.errors?.['required']"  class="text-danger">
                            Last Name is required
                          </span>
                        </div>

                        <div class="mb-20">
                          <label for="email-id">Email Address <span>*</span></label>
                          <input id="email" type="text" placeholder="Email Address" formControlName="email" />
                          <span *ngIf="formSubmitted && registerForm.controls?.['email']?.errors?.['required']" class="text-danger" >
                            Email is required and must be a valid email address
                          </span>
                          <span class="text-danger" *ngIf="formSubmitted && registerForm.controls?.['email']?.errors?.['email']">Email is invalid.</span>
                        </div>

                        <div class="mb-30">
                          <label for="pass">password <span>*</span></label>
                          <input id="password" type="password" placeholder="Enter password" formControlName="password" />
                          <span *ngIf="formSubmitted && (registerForm.controls?.['password']?.errors?.['required'] || registerForm.controls?.['password']?.errors?.['password']) "  class="text-danger">
                            Password is required and must be a 6 character
                          </span>
                        </div>
                        <div class="mb-30">
                          <label for="password_confirmation">Confirmation Password<span>*</span></label>
                          <input id="password_confirmation" type="password" placeholder="Enter Password Confirmation" formControlName="password_confirmation" />
                          <span *ngIf="formSubmitted && (registerForm.controls?.['password_confirmation']?.errors?.['required'] || registerForm.controls?.['password_confirmation']?.errors?.['password_confirmation']) "  class="text-danger">
                            Confirmation Password is required and must be a 6 character
                          </span>
                        </div>
                        <button type="submit" class="os-btn w-100">Register Now</button>
                        <div class="or-divide"><span>or</span></div>
                        <a routerLink="/login" class="os-btn os-btn-black w-100">login Now</a>
                    </form>
                </div>
            </div>
        </div>
    </div>
   </section>
  <!-- register Area End-->
</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
